module.exports = __webpack_public_path__ + "img/7.61153c44.svg";